import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { DomUtils } from "@tento-ui/dom";

import type { PageNode } from "@tento-ui/brand/page-model";
import { setTextOrHide, stringProp, stringsProp } from "./node-props";
import { tshVars } from "./tokens";

// Running prose on a 560px measure — the role that carries most of the page's
// words, and the one the current design has no place for at all: everything
// there is either a 33px heading or a 14px card body.
@component({ name: "tsh-prose" })
export class TshProse extends LonaWebComponent {
  private $heading: HTMLElement = this.$("heading");
  private $body: HTMLElement = this.$("body");

  bind(node: PageNode): void {
    setTextOrHide(this.$heading, stringProp(node, "heading"));
    DomUtils.clearChildren(this.$body);
    for (const paragraph of stringsProp(node, "paragraphs")) {
      const $p = document.createElement("p");
      $p.textContent = paragraph;
      this.$body.appendChild($p);
    }
  }

  static $styles = [
    tshVars,
    css`
      :host {
        display: block;
        padding: 48px var(--tsh-gutter, 32px) 0;
        font-family: var(--tsh-mono);
        color: var(--tsh-muted, #525252);
      }

      #frame {
        max-width: var(--tsh-measure, 560px);
      }

      h2 {
        --font-size: var(--h2-size);
        --line-height-ratio: 1.429;
        --margin-top: 0px;
        --margin-bottom: 24.7px; /* 12 box + 5.21 + 7.50 trims */
        font-weight: 700;
        color: var(--tsh-fg, #171717);
      }

      /* 21px of box between paragraphs. Authored 36 because BOTH siblings are
         trimmed and each loses 7.50 at this ratio — at 21 it renders 6, and the
         column reads as one undifferentiated block. */
      #body p {
        --font-size: var(--p-size);
        --line-height-ratio: 1.75;
        --margin-top: 0px;
        --margin-bottom: 36px;
      }

      #body p:last-child {
        --margin-bottom: 0px;
      }

      [hidden] {
        display: none !important;
      }
    `,
  ];

  static $html = html`
    <div id="frame">
      <h2 id="heading"></h2>
      <div id="body"></div>
    </div>
  `;
}
